var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.10581 0C3.6291 0 0 3.58172 0 7.99999C0 12.4183 3.6291 16 8.10581 16C12.5825 16 16.2116 12.4183 16.2116 7.99999C16.2116 3.58172 12.5825 0 8.10581 0ZM11.5891 9.36804C11.7692 9.36804 11.9166 9.22064 11.9166 9.04048V7.51191C11.9166 7.33175 11.7692 7.18436 11.5891 7.18436H9.07783V4.67313C9.07783 4.49297 8.93043 4.34557 8.75028 4.34557H7.22171C7.04155 4.34557 6.89415 4.49297 6.89415 4.67313V7.18436H4.38293C4.20277 7.18436 4.05537 7.33175 4.05537 7.51191V9.04048C4.05537 9.22064 4.20277 9.36804 4.38293 9.36804H6.89415V11.8793C6.89415 12.0594 7.04155 12.2068 7.22171 12.2068H8.75028C8.93043 12.2068 9.07783 12.0594 9.07783 11.8793V9.36804H11.5891Z",
    fill: "#65707B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default ForwardRef;